import React from 'react'
import {Link} from 'react-router-dom'
import exeCardBg from './images/exe-card-bg.jpg'
import namgelLama from './images/namgel-lama.jpg'
import garabDai from './images/garab-dai.jpg'
import karmaSherpa from './images/karma-sherpa.jpg'
import lamaDai from './images/lama-dai.jpg'
import kumarDai from './images/kumar-dai.jpg'
import tenzinDai from './images/tenzin-dai.jpg'

import './executive.css'

function Executive(){
    return(
        <div className="container-fluid py-4 executive-bg">
            <div className="text-center executive-container">
                <div className="row mb-3">
                    <div className="col mb-4">
                        <h2 className="p-1 mb-1Name" id="executive-heading">Executive Members</h2>
                    </div>
                </div>
                <div className="executive-cards-wrapper mb-1">
                    <div className="executive-card-wrapper">
                        <div className="executive-card border-0">
                            <div className="executive-img-container">
                                <img src ={exeCardBg} alt="" className="executive-img-bg" />
                                <img src={tenzinDai} alt="" className="card-img-top img-fluid mb-1 executive-img" />
                            </div>
                            <div className="card-body executive-card-body">
                                <h3 className="text-nowrap">Tenzin Sherpa</h3>
                                <h5>President</h5>
                                <div className="d-flex flex-row justify-content-center">
                                    <div className="p-1">
                                        <Link to="#">
                                            <i className="fab fa-facebook fa-lg"></i>
                                        </Link>
                                    </div>
                                    <div className="p-1">
                                        <Link to="#">
                                            <i className="fab fa-instagram fa-lg"></i>
                                        </Link>
                                    </div>
                                </div>    
                            </div>
                        </div>
                    </div>
                    <div className="executive-card-wrapper">
                            <div className="executive-card border-0">
                                <div className="executive-img-container">
                                    <img src ={exeCardBg} alt="" className="executive-img-bg" />
                                    <img src={garabDai} alt="" className="card-img-top img-fluid mb-1 executive-img" />
                                </div>
                                <div className="card-body executive-card-body">
                                    <h3 className="text-nowrap">Garab Dorjee</h3>
                                    <h5>Vice President</h5>
                                    <div className="d-flex flex-row justify-content-center">
                                        <div className="p-1">
                                            <Link to="#">
                                                <i className="fab fa-facebook fa-lg"></i>
                                            </Link>
                                        </div>
                                        <div className="p-1">
                                            <Link to="#">
                                                <i className="fab fa-instagram fa-lg"></i>
                                            </Link>
                                        </div>
                                    </div>    
                                </div>
                            </div>
                        </div>
                
                    <div className="executive-card-wrapper">
                        <div className="executive-card  border-0">
                            <div className="executive-img-container">
                                    <img src ={exeCardBg} alt="" className="executive-img-bg" />
                                    <img src={lamaDai} alt="" className="card-img-top img-fluid mb-1 executive-img" />
                            </div>
                            <div className="card-body executive-card-body">
                                <h3 className="text-nowrap">Wangla Lama</h3>
                                <h5>Club Advisor</h5>
                                <div className="d-flex flex-row justify-content-center">
                                        <div className="p-1">
                                            <Link to="#">
                                                <i className="fab fa-facebook fa-lg"></i>
                                            </Link>
                                        </div>
                                        <div className="p-1">
                                            <Link to="#">
                                                <i className="fab fa-instagram fa-lg"></i>
                                            </Link>
                                        </div>
                                    </div>    
                            </div>
                        </div>
                    </div>
                    <div className="executive-card-wrapper">
                            <div className="executive-card border-0">
                                <div className="executive-img-container">
                                    <img src ={exeCardBg} alt="" className="executive-img-bg" />
                                    <img src={kumarDai} alt="" className="card-img-top img-fluid mb-1 executive-img" />
                                </div>
                                <div className="card-body executive-card-body">
                                    <h3 className="text-nowrap">Kumar Sherchan</h3>
                                    <h5>Manager</h5>
                                    <div className="d-flex flex-row justify-content-center">
                                        <div className="p-1">
                                            <Link to="#">
                                                <i className="fab fa-facebook fa-lg"></i>
                                            </Link>
                                        </div>
                                        <div className="p-1">
                                            <Link to="#">
                                                <i className="fab fa-instagram fa-lg"></i>
                                            </Link>
                                        </div>
                                    </div>    
                                </div>
                            </div>
                    </div>
                    <div className="executive-card-wrapper">
                            <div className="executive-card border-0">
                                <div className="executive-img-container">
                                    <img src ={exeCardBg} alt="" className="executive-img-bg" />
                                    <img src={karmaSherpa} alt="" className="card-img-top img-fluid mb-1 executive-img" />
                                </div>
                                <div className="card-body executive-card-body">
                                    <h3 className="text-nowrap">Karma Sherpa</h3>
                                    <h5>Treasurer</h5>
                                    <div className="d-flex flex-row justify-content-center">
                                        <div className="p-1">
                                            <Link to="#">
                                                <i className="fab fa-facebook fa-lg"></i>
                                            </Link>
                                        </div>
                                        <div className="p-1">
                                            <Link to="#">
                                                <i className="fab fa-instagram fa-lg"></i>
                                            </Link>
                                        </div>
                                    </div>    
                                </div>
                            </div>
                    </div>
                    <div className="executive-card-wrapper">
                            <div className="executive-card border-0">
                                <div className="executive-img-container">
                                    <img src ={exeCardBg} alt="" className="executive-img-bg" />
                                    <img src={namgelLama} alt="" className="card-img-top img-fluid mb-1 executive-img" />
                                </div>
                                <div className="card-body executive-card-body">
                                    <h3 className="text-nowrap">Namgel Lama</h3>
                                    <h5>Sponsor</h5>
                                    <div className="d-flex flex-row justify-content-center">
                                        <div className="p-1">
                                            <Link to="#">
                                                <i className="fab fa-facebook fa-lg"></i>
                                            </Link>
                                        </div>
                                        <div className="p-1">
                                            <Link to="#">
                                                <i className="fab fa-instagram fa-lg"></i>
                                            </Link>
                                        </div>
                                    </div>    
                                </div>
                            </div>
                    </div>
                </div>
            </div>
            <div className="row py-3">
                <div className="col text-center">
                    <button type="button" className="btn btn-outline  waves-effect many-more-button gallery-button">View More +</button>
                    <br />
                </div>
            </div>
        </div>
    )
}

export default Executive